import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=950d4854&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950d4854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('950d4854')) {
      api.createRecord('950d4854', component.options)
    } else {
      api.reload('950d4854', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=950d4854&scoped=true&", function () {
      api.rerender('950d4854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Header.vue"
export default component.exports